import * as React from 'react';
import './index.scss';

type LivePageErrorProps = {
    title: string;
    text: string;
    buttonText: string;
    onClick: () => void;
};

export const LivePageError: React.FC<LivePageErrorProps> = React.memo(function LivePageError(
    props: LivePageErrorProps
) {
    const { title, text, buttonText, onClick } = props;

    return (
        <div className="live-page-error" data-testid="live-page-error" role="status">
            <p className="live-page-error__heading">{title}</p>
            <p className="live-page-error__text">{text}</p>
            <button type="button" className="live-page-error__button" onClick={onClick}>
                {buttonText}
            </button>
        </div>
    );
});
